import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import {Button, Message} from '@aperza/ui';

export default class ClipModal extends React.Component {

  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
  };

  closeClipModal = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  hideClipSuccessModal = (e) => {
    let checked = e.target.checked;
    localStorage.setItem("isClipSuccessModalChecked", checked);
  };

  render() {
    return (
      <Modal
        show={this.props.open}
        onHide={::this.closeClipModal}
        size={'sm'}
        id="ClipEmailSuccessModal"
        dialogClassName={'ClipEmailSuccessModal'}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <Message messageId={'clip.pageClip.title'} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Message messageId={'clip.pageClip.notification'} />
        </Modal.Body>
        <Modal.Footer className="flex-column">
          <div className="mb-4 text-center font-weight-light">
            <Form.Group controlId="formDoNotDisplayAgain">
              <Form.Check type="checkbox" onChange={this.hideClipSuccessModal} label={<Message messageId="doNotDisplayAgain" />} />
            </Form.Group>
          </div>
          <Button size="xl" type={Button.TYPE_DEFAULT} wide={true} onClick={::this.closeClipModal}><Message messageId="close" /></Button>
        </Modal.Footer>
      </Modal>
    )
  }

}
